import { ComponentProps } from 'react'

import { joinStyles } from 'app/utils/theme'

import { ColorDot, SizeDot } from 'app/types/ui/dot'
import * as styles from './index.css'

type DotProperties = ComponentProps<'div'> & {
    size?: SizeDot
    color?: ColorDot
}

/** Dot UI component. */
export const Dot = ({
    className,
    size = 'medium',
    color = 'success',
    ...properties
}: Readonly<DotProperties>): JSX.Element => {
    return (
        <div
            className={joinStyles(
                styles.base,
                styles.size[size],
                styles.color[color],
                className,
            )}
            {...properties}
        />
    )
}
